// extracted by mini-css-extract-plugin
export var chatHtmlText = "_o3-2";
export var chatLink = "_o3-0";
export var chatText = "_o3-1";